import React, { useEffect } from 'react';
import Layout from './Layout';
import Splash from '../splash/Splash';
import Game from '../game/Game';
import { useModal } from '../../context/ModalContext';
import { useGame } from '../../context/GameContext';
import { useParams } from 'react-router';
import WinModal from '../modals/WinModal';

function HomePage() {
  const { openModal, activeModal, closeModal } = useModal();
  const {
    mode,
    gameState,
    gameSetupData,
    setGameState,
    playGameSplash: playReal,
    isLoading,
    setMode,
    isArchiveGame,
  } = useGame();

  const { dateString } = useParams<{ dateString?: string }>();
  const { setGameDate } = useGame();

  useEffect(() => {
    setMode('splash');
  }, [setMode]);

  useEffect(() => {
    if (dateString) setGameDate(new Date(dateString));
    else setGameDate(undefined); // default to today
  }, [dateString, setGameDate]);

  const splashLoading = !gameSetupData || !gameState || isLoading;

  return (
    <>
      {(mode === 'splash' || splashLoading) && (
        <Splash
          isLoading={splashLoading}
          gameDate={gameSetupData?.date}
          onStartRealGameClick={playReal}
          isArchiveGame={isArchiveGame}
        />
      )}

      {mode !== 'splash' && gameState && (
        <Layout>
          <WinModal isOpen={activeModal === 'win'} onClose={closeModal} />
          <Game
            gameState={gameState}
            setGameState={setGameState}
            resultsOnClick={() => openModal('win')}
          />
        </Layout>
      )}
    </>
  );
}

export default HomePage;
